import { UPDATE_USER } from "../constants/User";
import { AUTHENTICATED, SIGNOUT_SUCCESS } from "../constants/Auth";

const initUser = {
	name: null,
	email: null,
	role: null,
	grupo_usuario: null,
	id_comercializador: null,
	id_parceiro: null,
};

const user = (state = initUser, action) => {
	switch (action.type) {
		case AUTHENTICATED:
		case SIGNOUT_SUCCESS:
			return { ...initUser };
		case UPDATE_USER: {
			// Preserva grupo anterior se o /menu vier sem descricao (payload parcial/null).
			const incoming = action.grupo_usuario;
			const mergedGrupo =
				incoming && incoming.descricao ? incoming : state.grupo_usuario;
			return {
				...state,
				name: action.name,
				email:
					action.email !== undefined ? action.email : state.email,
				role: action.role,
				grupo_usuario: mergedGrupo,
				id_comercializador:
					action.id_comercializador !== undefined
						? action.id_comercializador
						: state.id_comercializador,
				id_parceiro:
					action.id_parceiro !== undefined
						? action.id_parceiro
						: state.id_parceiro,
			};
		}
		default:
			return state;
	}
};

export default user;
